import { mParticleEventType } from '@treatwell/ui';
import { trackEvent } from 'js/mparticle/mParticleTracking';
import debounce from 'p-debounce';

export type TriggerContext = 'home' | 'browse';

export type SearchButtonClickedEventAttributes = {
  countryCode: string;
  isMobile: boolean;
  isValid: boolean;
  searchType?: 'treatment_type' | 'treatment' | 'venue_type' | 'venue';
  treatmentId?: string;
  treatmentTypeId?: string;
  venueTypeId?: string;
  venueId?: string;
  locationType?: string;
  locationName?: string;
};

export const debounceTrackMParticleSearch = debounce(
  ({
    country,
    isWebMobile,
    triggerContext,
    searchType,
    searchTerm,
    language,
  }: {
    country: string;
    isWebMobile: boolean;
    triggerContext: TriggerContext;
    searchType: 'treatment' | 'venue';
    searchTerm: string;
    language: string;
  }) => {
    trackEvent('no_matching_results_shown', mParticleEventType.Other, {
      country,
      platform: 'web',
      is_web_mobile: isWebMobile,
      trigger_context: triggerContext,
      search_type: searchType,
      search_term: searchTerm,
      language,
    });
  },
  300
);

export const searchTreatmentBarClickedEvent = (
  countryCode: string,
  isMobile: boolean,
  triggerContext: TriggerContext
) => {
  trackEvent('search_treatment_bar_clicked', mParticleEventType.Other, {
    country: countryCode,
    platform: 'web',
    is_web_mobile: isMobile,
    trigger_context: triggerContext,
  });
};

export const searchButtonClickedEvent = ({
  countryCode,
  isMobile,
  isValid,
  searchType,
  treatmentTypeId,
  treatmentId,
  venueTypeId,
  venueId,
  locationType,
  locationName,
}: SearchButtonClickedEventAttributes) => {
  trackEvent('search_button_clicked', mParticleEventType.Other, {
    country: countryCode,
    platform: 'web',
    is_web_mobile: isMobile,
    trigger_context: 'home',
    is_valid: isValid,
    search_type: searchType,
    treatment_type_id: treatmentTypeId,
    treatment_id: treatmentId,
    venue_type_id: venueTypeId,
    venue_id: venueId,
    location_type: locationType,
    location_name: locationName,
  });
};
